import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';
@Injectable({
  providedIn: 'root'
})
export class WithdrawalService {

  constructor(private http: HttpClient) {}

   getWithdrawalData(userSession: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    return this.http.get(
      `${ApiConfig.baseUrl}/withdrawal/get-withdrawal-data`,
      { headers }
    );
  }
  postWithdraw(userSession: string, 
               authorizationPin: string, 
               withdrawalMethodId: string, 
               serviceFeeId: string,
               bankAccountId: string,
               bankId: string,
               accountNumber: string,
               amount: number, 
               serviceFee: number, 
               totalAmount: number): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

    const request = {
      authorizationPin,
      withdrawalMethodId,
      serviceFeeId,
      bankAccountId,
      bankId,
      accountNumber,
      amount,
      serviceFee,
      totalAmount
    };
    return this.http.post(
    `${ApiConfig.baseUrl}/withdrawal/withdraw`,
    request,
    {
        headers,
        observe: 'response'
    }
    );
  }
}